export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      deliveryTypeMsts: [
        {
          deliveryTypeMstId: 7,
          deliveryTypeMstUuid: "deliverytypemst007",
          deliveryTypeName: "メールマガジン",
          deliveryType: "mailmag",
          deliveryPriorityKbn: 1,
          cmsDisplayKbn: 1,
          ledDisplayKbn: 1,
          deliveryTypeStatus: 1,
          deliveryConfigFlg: 1,
          linkedNoticeTypes: [
            {
              noticeTypeMstUuid: "noticeType001",
              noticeTypeName: "テキストのみ",
            },
          ]
        },
        {
          deliveryTypeMstId: 6,
          deliveryTypeMstUuid: "deliverytypemst006",
          deliveryTypeName: "警戒告知",
          deliveryType: "keikai",
          deliveryPriorityKbn: 2,
          cmsDisplayKbn: 1,
          ledDisplayKbn: 2,
          ledOnInterval: 300,
          deliveryTypeStatus: 1,
          deliveryConfigFlg: 1,
          linkedNoticeTypes: [
            {
              noticeTypeMstUuid: 'noticeType012',
              noticeTypeName: '警戒レベル告知',
            },
          ]
        },
        {
          deliveryTypeMstId: 5,
          deliveryTypeMstUuid: "deliverytypemst005",
          deliveryTypeName: "御用聞き",
          deliveryType: "ordertake",
          deliveryPriorityKbn: 1,
          cmsDisplayKbn: 0,
          ledDisplayKbn: 3,
          deliveryTypeStatus: 1,
          deliveryConfigFlg: 0,
          linkedNoticeTypes: [
            {
              noticeTypeMstUuid: 'noticeType011',
              noticeTypeName: '御用聞き',
            },
          ]
        },
        {
          deliveryTypeMstId: 4,
          deliveryTypeMstUuid: "deliverytypemst004",
          deliveryTypeName: "見守り",
          deliveryType: "follow",
          deliveryPriorityKbn: 1,
          cmsDisplayKbn: 1,
          ledDisplayKbn: 1,
          deliveryTypeStatus: 1,
          deliveryConfigFlg: 1,
          linkedNoticeTypes: [
            {
              noticeTypeMstUuid: 'noticeType010',
              noticeTypeName: '見守り',
            },
          ]
        },
        {
          deliveryTypeMstId: 3,
          deliveryTypeMstUuid: "deliverytypemst003",
          deliveryTypeName: "サイネージ",
          deliveryType: "signage",
          deliveryPriorityKbn: 1,
          cmsDisplayKbn: 1,
          ledDisplayKbn: 1,
          deliveryTypeStatus: 1,
          deliveryConfigFlg: 1,
          linkedNoticeTypes: [
            {
              noticeTypeMstUuid: 'noticeType008',
              noticeTypeName: '画像のみ',
            },
            {
              noticeTypeMstUuid: 'noticeType007',
              noticeTypeName: '音声定時放送',
            },
            {
              noticeTypeMstUuid: 'noticeType006',
              noticeTypeName: 'アンケート',
            },
            {
              noticeTypeMstUuid: 'noticeType005',
              noticeTypeName: '音声告知',
            },
            {
              noticeTypeMstUuid: 'noticeType004',
              noticeTypeName: 'PDF',
            },
            {
              noticeTypeMstUuid: 'noticeType003',
              noticeTypeName: '動画添付',
            },
            {
              noticeTypeMstUuid: 'noticeType002',
              noticeTypeName: '画像添付',
            },
            {
              noticeTypeMstUuid: "noticeType001",
              noticeTypeName: "テキストのみ",
            },
          ]
        },
        {
          deliveryTypeMstId: 2,
          deliveryTypeMstUuid: "deliverytypemst002",
          deliveryTypeName: "家族のお知らせ",
          deliveryType: "family_info",
          deliveryPriorityKbn: 2,
          cmsDisplayKbn: 1,
          ledDisplayKbn: 1,
          deliveryTypeStatus: 1,
          deliveryConfigFlg: 1,
          linkedNoticeTypes: [
            {
              noticeTypeMstUuid: 'noticeType005',
              noticeTypeName: '音声告知',
            },
            {
              noticeTypeMstUuid: 'noticeType003',
              noticeTypeName: '動画添付',
            },
            {
              noticeTypeMstUuid: 'noticeType002',
              noticeTypeName: '画像添付',
            },
            {
              noticeTypeMstUuid: "noticeType001",
              noticeTypeName: "テキストのみ",
            },
          ]
        },
        {
          deliveryTypeMstId: 1,
          deliveryTypeMstUuid: "deliverytypemst001",
          deliveryTypeName: "お知らせ",
          deliveryType: "normal",
          deliveryPriorityKbn: 1,
          cmsDisplayKbn: 1,
          ledDisplayKbn: 1,
          deliveryTypeStatus: 1,
          deliveryConfigFlg: 1,
          linkedNoticeTypes: [
            {
              noticeTypeMstUuid: 'noticeType007',
              noticeTypeName: '音声定時放送',
            },
            {
              noticeTypeMstUuid: 'noticeType006',
              noticeTypeName: 'アンケート',
            },
            {
              noticeTypeMstUuid: 'noticeType005',
              noticeTypeName: '音声告知',
            },
            {
              noticeTypeMstUuid: 'noticeType004',
              noticeTypeName: 'PDF',
            },
            {
              noticeTypeMstUuid: 'noticeType003',
              noticeTypeName: '動画添付',
            },
            {
              noticeTypeMstUuid: 'noticeType002',
              noticeTypeName: '画像添付',
            },
            {
              noticeTypeMstUuid: "noticeType001",
              noticeTypeName: "テキストのみ",
            },
          ]
        }
      ]
    }
  }
}